import {
  GoogleGeminiAdapter,
  ReplicateAdapter,
  CloudflareWorkersAiAdapter,
} from '@byokapp/providers'
import type { ProviderAdapter } from '@byokapp/types'

export const PROVIDER_ADAPTERS: Map<string, ProviderAdapter> = new Map<string, ProviderAdapter>([
  ['google-gemini', new GoogleGeminiAdapter()],
  ['replicate', new ReplicateAdapter()],
  ['cloudflare-ai', new CloudflareWorkersAiAdapter()],
])

export function getAdapter(providerId: string): ProviderAdapter | undefined {
  return PROVIDER_ADAPTERS.get(providerId)
}
